<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('internship_application') + ' - ' + $t('detail')" :isFilter="false" />
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('internship_application') + ' - ' + $t('detail')" :isFilter="false" />
			</template>
			<b-row>
				<b-col cols="12" md="6" class="mb-4 mb-md-0 d-flex">
					<b-card :header="$t('student_information')" class="soft mb-5">
						<b-row>
							<b-col cols="12" sm="6" md="12" xl="6">
								<b-form-group :label="$t('student_number')">
									<span>{{ internshipData.student_number }}</span>
								</b-form-group>
							</b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('name_surname')">
									<span>
										{{ internshipData.name + ' ' + internshipData.surname }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('email')">
									<span>
										{{ internshipData.email }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('faculty')">
                                    <span>{{ getLocaleText(internshipData, 'faculty_name') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('department')">
                                    <span>{{ getLocaleText(internshipData, 'department_name') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('program')">
                                    <span>{{ getLocaleText(internshipData, 'program_name') }}</span>
                                </b-form-group>
                            </b-col>
						</b-row>
					</b-card>
				</b-col>
				<b-col cols="12" md="6">
					<b-card :header="$t('internship_information')" class="soft mb-5">
						<b-row>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('company_name')">
									<span>
										{{ internshipData.company_name }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('company_phone')">
									<span>
										{{ internshipData.company_phone }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('responsiblePerson')">
									<span>
										{{ internshipData.responsible_name + ' ' + internshipData.responsible_surname }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('responsible_email')">
									<span>
										{{ internshipData.responsible_email }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('unit')">
									<span>
										{{ internshipData.unit }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('day_count')">
									<span>
										{{ internshipData.day_count }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('course_code')">
									<span>
										{{ internshipData.course_code }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('type')">
									<span>
									{{ form.type === 'voluntary' ? $t('voluntary') : $t('mandatory') }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('start_date')">
									<span>
										{{ internshipData.start_date }}
									</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="12" xl="6">
                                <b-form-group :label="$t('end_date')">
									<span>
										{{ internshipData.end_date }}
									</span>
                                </b-form-group>
                            </b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
			<div>
				<div class="mb-3 d-inline-block"></div>
				<div v-if="internshipData && step.id">
					<h6 class="text-uppercase mb-4">{{ $t('approval_procedures').toUpper() }}</h6>
					<ValidationObserver ref="updateForm">
						<div class="row">
							<div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('status')">
                                        <template>
                                            <div>
                                                <multiselect placeholder="Yok" v-model="updateForm.status"
                                                             :options="computeStatusOptions"
                                                             :custom-label="statusOptionsCustomLabel" :select-label="''"
                                                             :selected-label="''" :deselect-label="''" :searchable="false">
                                                </multiselect>
                                                <div class="invalid-feedback d-block" v-if="errors[0]"
                                                     v-html="errors[0]"></div>
                                            </div>
                                        </template>
                                    </b-form-group>
                                </ValidationProvider>
							</div>
							<div class="col-12 col-md-6 col-lg-6 col-xl-9">
								<ValidationProvider name="explanation" rules="required" v-slot="{ valid, errors }">
									<b-form-group :label="$t('explanation')">
										<b-form-textarea no-resize rows="4" class="h-40 h-auto-sm" maxlength="100"
										                 v-model="updateForm.reason"></b-form-textarea>
										<div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
									</b-form-group>
								</ValidationProvider>
							</div>
						</div>
						<b-form-group>
							<b-button variant="primary" @click="internshipUpdate">
                                {{ $t('update').toUpper() }}
							</b-button>
						</b-form-group>
					</ValidationObserver>
				</div>
				<div v-if="Object.assign(steps).length">
					<b-table :empty-text="$t('there_are_no_records')" bordered striped responsive :items="steps"
					         :fields="[
                            { key: 'rank', label: this.toUpperCase('rank'), thClass: 'text-center', tdClass: 'text-center' },
                            { key: 'approvers', label: this.toUpperCase('can_approvers'), thClass: 'text-center' },
                            { key: 'approved', label: this.toUpperCase('approved_by'), thClass: 'text-center' },
                            { key: 'status', label: this.toUpperCase('status'), thClass: 'text-center' },
                            { key: 'reason', label: this.toUpperCase('explanation'), thClass: 'text-center' },
                            { key: 'updated_at', label: this.toUpperCase('updated_at'), thClass: 'text-center' },
                            { key: 'buttons', label: '', tdClass:'width-200'}
                        ]" show-empty sort-by="rank" class="mb-3 table-dropdown no-scrollbar border rounded">
						<template #cell(approvers)="data">
                            <span v-for="approver in data.item.approvers">
                                {{ getLocaleText(approver, 'explanation') }} <br>
                            </span>
						</template>
						<template #cell(approved)="data">
                            <span v-for="approver in data.item.approved">
                                {{ approver.name }} {{ approver.surname }}<br>
                            </span>
						</template>
						<template #cell(status)="data">
							{{ $i18n.locale == 'tr' ? data.item.status_name : data.item.status_name_en }}
						</template>
                        <template #cell(buttons)="row">
                            <div class="d-flex">
                                <b-button variant="outline-success"
                                          size="xs"
                                          v-if="row.item.allow_set_active==true && checkPermission('approvalstep_setactive')"
                                          @click="setActive(row.item.id)">
                                    {{ $t('set_as_active_step').toUpper() }}
                                </b-button>
                            </div>
                        </template>
					</b-table>
				</div>
			</div>
		</app-layout>
	</div>
</template>
<script>
	// Template
	import AppLayout from "@/layouts/AppLayout";
	import Header from "@/layouts/AppLayout/Header";
	import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

	// Services
	import InternshipApplicationService from "@/services/InternshipApplicationService";
	import ApprovalStepService from "@/services/ApprovalStepService";

	// Components
	import CommonModal from "@/components/elements/CommonModal"

// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"

	export default {
		components: {
			AppLayout,
			Header,
			HeaderMobile,
			CommonModal,
			ValidationProvider,
			ValidationObserver,
		},
		data() {
			return {
				id: this.$route.params.id,
				internshipData: {},
				step: {},
				steps: {},
				messages: {},
				statuses: {},
				updateForm: {
					status: null,
					reason: null,
				},
				form: {
					explanation: ''
				},
	            formLoading: false,
				fields: [
					{
						key: 'created_by',
						label: this.toUpperCase('created_by'),
						thClass: 'text-left',
					},
					{
						key: 'message',
						label: this.toUpperCase('message'),
						thClass: 'text-left'
					},
					{
						key: 'created_at',
						label: this.toUpperCase('created_at'),
						thClass: 'text-left',
						formatter: this.formatDate,
					},
				],
				isTableVisible: false,
                formProcess: null,
                statusOptions: [
                    { text: this.$t('approved'), value: true },
                    { text: this.$t('declined'), value: false },
                ],
			}
		},

		metaInfo() {
			return {
				title: this.$t('internship_application') + ' - ' + this.$t('detail')
			}
		},
		created() {
			this.getData();

		},
		computed: {
            computeStatusOptions() {
                let options = [];
                if (this.statuses) {
                    for (const item in this.statuses) {
                        options.push(item);
                    }
                }
                return options;
            },
		},
		methods: {
			getData() {
				InternshipApplicationService.get(this.id)
				.then(response => {
                    this.internshipData = response.data.data;
                    this.step = this.internshipData.step == null ? {} : this.internshipData.step;
					if (this.internshipData.step != null) {
                        this.statuses = this.internshipData.step.statuses;
                    }
					this.steps = this.internshipData.steps == null ? {} : this.internshipData.steps;
				})
				.catch(e => {
					//this.$router.push('/404')
					this.$toast.error(e.data.message)
				})

			},
			async internshipUpdate() {
                if(this.checkPermission('internshipapplication_makeapplication')){
                    const isValid = await this.$refs.updateForm.validate();
                    if (isValid) {
                        this.$swal.fire({
                            title: this.$t('warning'),
                            text: this.$t('leave_of_absence_statement'),
                            showCancelButton: true,
                            confirmButtonText: this.$t('yes'),
                            cancelButtonText: this.$t('no'),
                        }).then((result) => {
                            if (result.isConfirmed) {
                                InternshipApplicationService.update(this.step.id, this.updateForm)
                                                     .then(response => {
                                                         this.$toast.success(this.$t('api.' + response.data.message));
                                                         this.getData()
                                                     })
                                                     .catch(error => {
                                                         if (error.status == 422) {
                                                             if (error.data.errors.status) {
                                                                 this.$refs.updateForm.errors.status.push(error.data.errors.status[0]);
                                                             }
                                                             if (error.data.errors.reason) {
                                                                 this.$refs.updateForm.errors.explanation.push(error.data.errors.reason[0]);
                                                             }
                                                         }
                                                         if (error.status == 406) {
                                                             this.$toast.error(this.$t('api.' + error.data.message));
                                                         }
                                                     });
                            }
                        })
                    }
                } else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
			},
            statusOptionsCustomLabel(key) {
                let label = key;
                if (this.statuses[key]) {
                    label = this.$i18n.locale == 'tr' ? this.statuses[key].name : this.statuses[key].name_en;
                }
                return label;
            },
            setActive(id){
                this.$swal.fire({
                    text: this.$t('are_you_sure_to_set_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        ApprovalStepService.setActive(id).then(response=>{
                            this.showMessage(response);
                            this.getData();
                        }).catch(e=>{
                            this.showErrors(e);
                        });
                    }
                });
			},
		},
	};
</script>
